<div class='container-float'>

  <b-alert 
    v-model="show_alert" 
    variant="primary" 
    dismissible
    class="custom-alert"
  >
    Una nuova password è stata inviata all'indirizzo associato alla login, se la login risulta esistente.
  </b-alert>
  <b-row>
    <b-col cols="7">
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <img src="@/assets/imgs/logo.jpg" style='width: 10rem;margin-left: 1.5rem;'>
        </b-col>
        <b-col cols="3">
          <h3 style="margin-top: 7rem;font-weight: 600;">&nbsp;Listino prezzi</h3>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          &nbsp;
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="8">
          <h5 style="margin-left: -2.0em;">Inserisci la tua login e premi il pulsante per recuperare la password</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Login</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input v-model="username" placeholder="Inserisci la tua login" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-button @click="execute_recover" variant="primary" style="width: 100%;margin-left: 2.3rem;">Invia</b-button>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <p @click="goto_register">Non hai un account? &nbsp;<span style="font-weight: 600;color: darkred;cursor: pointer;">Registrati</span></p>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>
    </b-col>
    
  </b-row>


</div>